export class MessagingConstants {
  // NOTES
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly NOTES_UPDATE_NEW_NOTE    = 'NOTES_UPDATE_NEW_NOTE';
  static readonly NOTES_CREATE_BLANK_NOTE  = 'NOTES_CREATE_BLANK_NOTE';
  static readonly NOTES_CREATE_NOTE        = 'NOTES_CREATE_NOTE';
  static readonly NOTES_MINIMIZE           = 'NOTES_MINIMIZE';
  static readonly NOTES_FILTER             = 'NOTES_FILTER_BY_CATEGORY';
  static readonly NOTES_FILTER_OBJECT      = 'NOTES_FILTER_BY_GROUP_OBJECT';
  static readonly NOTES_FILTER_READY       = 'NOTES_FILTER_READY';
  static readonly NOTES_REFRESH            = 'NOTES_REFRESH';

  // WORLD PAY
  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // static readonly AR_WORLDPAY_PAYMENT_APPROVED = 'AR_WORLDPAY_PAYMENT_APPROVED';
  // static readonly AR_WORLDPAY_PAYMENT_CANCELED = 'AR_WORLDPAY_PAYMENT_CANCELED';
  // static readonly AR_TRIPOS_PAYMENT_APPROVED = 'AR_TRIPOS_PAYMENT_APPROVED';
  // static readonly AR_TRIPOS_PAYMENT_CANCELED = 'AR_TRIPOS_PAYMENT_CANCELED';

  // PATIENT
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly PATIENT_CHANGED    = 'PATIENT_CHANGED';
  static readonly PATIENT_LOADED     = 'PATIENT_LOADED';
  static readonly PATIENT_CHANGE_STARTLEDGER     = 'PATIENT_CHANGE_STARTLEDGER';
  static readonly DO_NOT_LOAD_CASE_VIEW = 'DO_NOT_LOAD_CASE_VIEW';
  static readonly RELOAD_PATIENT_FORMS = 'RELOAD_PATIENT_FORMS';
  //CHECK OUT PATIENT
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly CHECKOUT_PATIENT_COMPLETED = 'CHECKOUT_PATIENT_COMPLETED';
  static readonly CHECKOUT_PATIENT_START = 'CHECKOUT_PATIENT_START';
  //RELOAD SCHEDULE APPOINTMENTS
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly RELOAD_SCHEDULE_APPOINTMENTS = 'RELOAD_SCHEDULE_APPOINTMENTS';
  // FORMS
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly FORM_EDIT_START    = 'OP-LANDING-START-EDIT-FORM';
  static readonly FORM_ITEM_SAVED    = 'FORM_ITEM_SAVED';
  static readonly CASE_FORMS_REFRESH = 'CASE_FORMS_REFRESH';

  // ORGANIZER
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly IO_TAGS_UPDATED = 'IO_TAGS_UPDATED';
  static readonly OPEN_PREOP_IMAGES = 'OPEN_PREOP_IMAGES';
  // STUDIO
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly STUDIO_STOP_IMAGE_ROTATION = 'STUDIO_STOP_IMAGE_ROTATION';

  // CASES
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly CASES_REFRESH = 'CASES_REFRESH';
  static readonly CASES_REFRESH_SELECT_CASE = 'CASES_REFRESH_SELECT_CASE';
  static readonly CASE_CHANGED_EVENT = 'CASE_CHANGED_EVENT';
  static readonly CASE_VIEW_ITEM_CHANGED_EVENT = 'CASE_VIEW_ITEM_CHANGED_EVENT';
  static readonly CASE_START_VIEW    = '';
  static readonly CASE_VIEW_COLLAPSE = 'CASE_VIEW_COLLAPSE';
  static readonly ONLY_CASES_STATUS_REFRESH = 'ONLY_CASES_STATUS_REFRESH';

  // User
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly USER_ROLES_CHANGED = 'USER_ROLES_CHANGED';
  static readonly DOCTOR_UPDATE = 'DOCTOR_UPDATE';

  static readonly HEADER_MINIMIZE = 'HEADER_MINIMIZE';

  // MTI
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly MTI_AUTOFILL_CHANGED = 'MTI_AUTOFILL_CHANGED';

  // Treatment
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly PATIENT_TREATMENT_APPROVED = 'PATIENT_TREATMENT_APPROVED';
  static readonly PATIENT_TREATMENT_REJECTED = 'PATIENT_TREATMENT_REJECTED';

    // CONFIG
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  static readonly VALID_VALUES_REFRESH = 'VALID_VALUES_REFRESH';


  // Check Out Task
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // static PATIENT_RECORD = 'PATIENT_RECORD';
  // static FEES_PAGE = 'FEES_PAGE';
  // static ERX_PAGE = 'ERX_PAGE';
  // static PATIENT_CHANGE_START_RECEIVE_PAYMENT = 'PATIENT_CHANGE_START_RECEIVE_PAYMENT';


}
